
export default function scrollUI() {
  const buttons = document.querySelectorAll('.js-scroll-btn');

  buttons.forEach(button => {
    button.addEventListener('click', function () {
      const targetAttr = this.getAttribute('data-scroll-section');

      const targetSection = document.querySelector(`section[data-scroll-section="${targetAttr}"]`);

      if (targetSection) {
        const offsetTop = targetSection.getBoundingClientRect().top + window.pageYOffset - 80;
        
        window.scrollTo({
          top: offsetTop,
          behavior: 'smooth'
        });
      }
    });
  });
}
